export default __webpack_public_path__ + "static/media/fondo_inversion_panel.74de5e8b.png";